import { CouponInfo } from './vo/coupon-info.model';

/**
 * 注文単位値引クーポン一覧画面の値を管理するクラス
 *
 * @export KYMW7300Model
 * @class KYMW7300Model
 */
export class KYMW7300Model {
  public couponIssueCatalog: string;
  public receiptCatalog: string;
  public couponOrderCd: string;
  public couponCategory: string;
  public couponName: string;

  public totalNum: number = 0;
  public startDispNum: number = 0;
  public endDispNum: number = 0;
  public couponList: CouponInfo[] = [];

  public page: number = 1;

  // 検索時の条件保持用
  public searchedCouponIssueCatalog: string;
  public searchedReceiptCatalog: string;
  public searchedCouponOrderCd: string;
  public searchedCouponCategory: string;
  public searchedCouponName: string;

  get disabledPrev() {
    return (this.page > 1) ? false : true;
  }
  get disabledNext() {
    return (this.totalNum > this.endDispNum) ? false : true;
  }
}
